import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { ProjectsReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const projectsReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...ProjectsReducerHandlers.fetchProjectById,
    ...ProjectsReducerHandlers.createProject,
    ...ProjectsReducerHandlers.deleteProjectById,
    ...ProjectsReducerHandlers.toggleProjectArchivingById,
    ...ProjectsReducerHandlers.fetchChaptersAndResourcesByProjectId,
    ...ProjectsReducerHandlers.getBookSampleAndResourcesByProjectId,
    ...ProjectsReducerHandlers.fetchChaptersAndResourcesByUser,
    ...ProjectsReducerHandlers.getBookSampleAndResourcesByUser,
    ...ProjectsReducerHandlers.fetchDataToEditProject,
    ...ProjectsReducerHandlers.editProjectWithRelatedData,
    ...ProjectsReducerHandlers.fetchProofDataByProjectId,
    ...ProjectsReducerHandlers.fetchProofDataByUserId,
    ...ProjectsReducerHandlers.fetchProjectOverviewDataByProjectId,
    ...ProjectsReducerHandlers.fetchProjectOverviewDataByCustomerId,
    ...ProjectsReducerHandlers.getDataForProjectsList,
    ...ProjectsReducerHandlers.addWriterToProject,
    ...ProjectsReducerHandlers.getUserWithMiscData,
    ...ProjectsReducerHandlers.getDataToCompareVersions,
    ...ProjectsReducerHandlers.fetchPhotosAndResources,
    ...ProjectsReducerHandlers.moveToNextStageOfProject,
    ...ProjectsReducerHandlers.fetchTimelineDataByCustomer,
    ...ProjectsReducerHandlers.toggleUserEnableToEditDraft,
    ...ProjectsReducerHandlers.toggleUserEnableToEditOutline,
    ...ProjectsReducerHandlers.toggleUserEnableToDownloadOutline,
    ...ProjectsReducerHandlers.getProjectsDataForExcel,
    ...ProjectsReducerHandlers.customerReviewedUpgrades,
    ...ProjectsReducerHandlers.getDataFromHubspot,
    ...ProjectsReducerHandlers.approveBookDraftByCustomer,
    ...ProjectsReducerHandlers.editorSeenRequestForUpgrade,
    ...ProjectsReducerHandlers.editorSendDraftToDevelopmentalEditor,
    ...ProjectsReducerHandlers.editorSendDraftToProProofreader,
    ...ProjectsReducerHandlers.getProjectAndBookData,
    ...ProjectsReducerHandlers.getDataForUpgradesByProjectId,
    ...ProjectsReducerHandlers.cancelUpgradeRequest,
    ...ProjectsReducerHandlers.completeUpgradeRequest,
    ...ProjectsReducerHandlers.approveDraftByContentTeam,
    ...ProjectsReducerHandlers.getNextStageForProject,
  },
);

export default projectsReducer;
